import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import * as safeNumber from './types';

const mutations = {
  // 인터넷 가입 진행중 리스트 - 사용자
  [safeNumber.SET_SAFE_NUMBER](state, data) {
    console.log('SET_SAFE_NUMBER');
    console.log(data);
    state.safeNumber = data;
  },
};

export default mutations;
